import { TKIconProgressHolder } from 'assets/images/svgs'
import React from 'react'

const ProgressBar = ({ progress }) => {
  return (
    <div className='my-4 h-[10px] flex items-center bg-[#F0CA1833]'>
      <div className={`h-[10px] bg-[#F0CA18] ${progress}`}></div>
      <TKIconProgressHolder />
    </div>
  )
}

export default ProgressBar